/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Allow_Overlap_Aria_LabelInputs */

const en_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toggle Allow Overlap`)
};

const fr_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer/désactiver le chevauchement`)
};

const de_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überlappung zulassen/einschalten`)
};

const it_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attiva/disattiva la sovrapposizione`)
};

const ru_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разрешить перекрытие`)
};

const es_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activar/desactivar la superposición`)
};

const zh_cn2_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`切换允许重叠`)
};

const ja_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オーバーラップを許可する切り替え`)
};

const hi_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ओवरलैप की अनुमति दें टॉगल करें`)
};

const pt_pt2_timeline_allow_overlap_aria_label = /** @type {(inputs: Timeline_Allow_Overlap_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alternar Permitir Sobreposição`)
};

/**
* | output |
* | --- |
* | "Toggle Allow Overlap" |
*
* @param {Timeline_Allow_Overlap_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_allow_overlap_aria_label = /** @type {((inputs?: Timeline_Allow_Overlap_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Allow_Overlap_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timeline_allow_overlap_aria_label(inputs)
	if (locale === "de") return de_timeline_allow_overlap_aria_label(inputs)
	if (locale === "it") return it_timeline_allow_overlap_aria_label(inputs)
	if (locale === "ru") return ru_timeline_allow_overlap_aria_label(inputs)
	if (locale === "es") return es_timeline_allow_overlap_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_timeline_allow_overlap_aria_label(inputs)
	if (locale === "ja") return ja_timeline_allow_overlap_aria_label(inputs)
	if (locale === "hi") return hi_timeline_allow_overlap_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_timeline_allow_overlap_aria_label(inputs)
	return en_timeline_allow_overlap_aria_label(inputs)
});